import styled, { css } from 'styled-components';
import { ReactComponent as UpArrow } from '../../images/icons/icon_keyboard_arrow_up.svg';

const ContainerWidth = css`
  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.xs}) {
    width: 490px;
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm}) {
    width: 348px;
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.md}) {
    width: 382px;
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.lg}) {
    width: 499px;
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.xl}) {
    width: 554px;
  }
`;

export const StyledInputGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-self: center;
  padding: 19px 0;
  width: 286px;
  ${ContainerWidth}
`;

export const StyledQuestionContainer = styled.div`
  padding-top: 30%;
  justify-self: center;

  @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}) {
    padding-top: 20%;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.md}) {
    padding-top: 10%;
  }
`;

export const StyledPreviousQuestion = styled.div`
  height: 60px;
  button {
    height: auto;
    opacity: 0.3;
  }
`;

export const StyledSeekSkip = styled.div`
  position: fixed;
  bottom: 30px;
  padding: 1rem 0;
  width: 286px;
  ${ContainerWidth}
`;

export const StyledUpArrow = styled(UpArrow)`
  fill: ${(props) => props.theme.colors.white};
  vertical-align: middle;
  transform: scale(0.8);
`;